var React = require('react');

function UserManualInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"13.1","y":"3.54","width":"13.71","height":"2.92","key":0}),React.createElement("rect",{"x":"13.16","y":"15.21","width":"13.71","height":"2.92","key":1}),React.createElement("rect",{"x":"13.16","y":"21.17","width":"13.71","height":"2.92","key":2}),React.createElement("rect",{"x":"13.16","y":"27.12","width":"13.71","height":"2.92","key":3}),React.createElement("path",{"d":"M29.8,8.69H7.31v27.77h25.37V8.69h-2.89Zm0,24.88H10.2V11.58H29.8v21.99Z","key":4})]);
}

UserManualInline.defaultProps = {"width":"32","height":"32","id":"Warstwa_1","viewBox":"0 0 40 40"};

module.exports = UserManualInline;

UserManualInline.default = UserManualInline;
